import { SITE_BRAND_SEARCH_USER_GET } from "@/store/mutation-types";
import Vue from "vue";

const DEFAULT_STATE = {
  searchUsers: [],
};

const state = Object.assign({}, DEFAULT_STATE);

const mutations = {
  [SITE_BRAND_SEARCH_USER_GET](state, payload) {
    state.searchUsers = payload;
  },
};

const actions = {
  getSiteBrandSearchUser: function(
    context,
    {
      limit = 50,
      offset = 0,
      order_field = "score_of_profile",
      order = 0,
      keyword = "",
      search_mode = "all",
      search_institution_users = 1,
      exclude_site_brand_users = 0,
      exclude_need_verify_users = 0,
    } = {},
  ) {
    const { rootState, commit } = context;

    return Vue.http
      .get("site_brand_search_user", {
        params: {
          limit: limit,
          offset: offset,
          site_brand: rootState?.siteBrand?.brand,
          order_field: order_field,
          order: order,
          keyword: keyword,
          search_mode: search_mode,
          search_institution_users: search_institution_users,
          exclude_site_brand_users: exclude_site_brand_users,
          exclude_need_verify_users: exclude_need_verify_users,
          with_user_skill_tags: 1,
          with_user_profile: 1,
          with_user_country: 1,
          with_user_institution_setting: 1,
        },
      })
      .then((res) => {
        const { data = {} } = res;
        if (data?.result) {
          const { searchUsers } = context.state;
          if(offset<=0){
            commit(SITE_BRAND_SEARCH_USER_GET, [ ...data.data]);
          }else{
            commit(SITE_BRAND_SEARCH_USER_GET, [...searchUsers, ...data.data]);
          }
        }
        return data;
      });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
